<template>
  <div class="footer">
    <div v-for="(item, index) in list" :key="index">
      <div @click.stop="topage(item)">{{ item.title }}</div>
    </div>
    <div class="footer-container">
      <span>Copyright © 2024-2026 医疗信息化有限公司 版权所有</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      list: [
        {
          title: "隐私政策",
          url: "/other/xieyi/2",
        },
        {
          title: "用户协议",
          url: "/other/xieyi/3",
        },
        {
          title: "患者协议",
          url: "/other/xieyi/4",
        },
        {
          title: "注销协议",
          url: "/other/xieyi/5",
        },
        {
          title: "意见反馈",
          url: "/other/feedback",
        },
        {
          title: "关于我们",
          url: "/other/xieyi/1",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    topage(item) {
      this.$router.push(item.url + "?title=" + item.title);
    },
  },
};
</script>

<style scoped lang="postcss">
.footer {
  height: 50px;
  width: 100%;
  background-color: #fff;
  text-align: center;
  line-height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #999;
  div {
    margin: 0 10px;
    cursor: pointer;
    white-space: nowrap;
  }
}
</style>
